export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-share-8430161296a8c208fd219585fc74c730.svg";